export default __webpack_public_path__ + "static/media/productCurvyLines.58c56f77.png";